// extracted by mini-css-extract-plugin
export default {"game-modes-section":"gameModes_game-modes-section__2Yf4T","game-modes":"gameModes_game-modes__jfg+J","game-modes-heading":"gameModes_game-modes-heading__IEkUX"};